import { useState } from 'react';
import { useMutation } from '@tanstack/react-query';
import { v4 as uuidv4 } from 'uuid';
import storageManager from '@/api/storageManager';
import { registerAgeConsent } from '@/api/query/ageConsent';
import { useLanguageData } from '@/common/hooks/useLanguageData';
import { AGE_GATE_DECLINE_REDIRECT_URL } from '../constants/ageGate.constants';

const getOrCreateBrowserId = () => {
	let browserId = storageManager.browsingPerson.getBrowsingPersonId();

	if (!browserId) {
		browserId = uuidv4();
		storageManager.browsingPerson.setBrowsingPersonId(browserId);
	}

	return browserId;
};

const useAgeGate = () => {
	const t = useLanguageData('ageGate');
	const [isConfirmed, setIsConfirmed] = useState(() =>
		storageManager.ageGate.isConfirmed(),
	);

	const registerAgeConsentMutation = useMutation({
		mutationFn: registerAgeConsent,
	});

	const handleConfirm = () => {
		storageManager.ageGate.confirm();
		setIsConfirmed(true);

		registerAgeConsentMutation.mutate(getOrCreateBrowserId());
	};

	const handleDecline = () => {
		window.location.assign(AGE_GATE_DECLINE_REDIRECT_URL);
	};

	return {
		t,
		isConfirmed,
		isBlocked: false,
		handleConfirm,
		handleDecline,
	};
};

export default useAgeGate;
